import api from '../utils/api';
import config from '../config';

const vneidAccountService = {
  // Get VNeID accounts list with pagination and filtering
  getAccounts: async (params = {}) => {
    return api.get(config.endpoints.vneidAccounts.list, params);
  },

  // Get VNeID account by ID
  getAccountById: async (id) => {
    return api.get(`${config.endpoints.vneidAccounts.getById}/${id}`);
  },

  // Create new VNeID account
  createAccount: async (accountData) => {
    return api.post(config.endpoints.vneidAccounts.create, accountData);
  },

  // Update VNeID account
  updateAccount: async (id, accountData) => {
    return api.put(`${config.endpoints.vneidAccounts.update}/${id}`, accountData);
  },

  // Delete VNeID account
  deleteAccount: async (id) => {
    return api.delete(`${config.endpoints.vneidAccounts.delete}/${id}`);
  },

  // Bulk delete VNeID accounts
  bulkDeleteAccounts: async (ids) => {
    return api.delete(config.endpoints.vneidAccounts.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null, // Use repeat format: ?ids=1&ids=2 instead of ?ids[0]=1&ids[1]=2
      },
    });
  },

  // Toggle account status (active/locked)
  toggleAccountStatus: async (id) => {
    const endpoint = config.endpoints.vneidAccounts.toggleStatus.replace('{id}', id);
    return api.put(endpoint);
  },

  // Regenerate API key
  regenerateApiKey: async (id) => {
    const endpoint = config.endpoints.vneidAccounts.regenerateKey.replace('{id}', id);
    return api.put(endpoint);
  },

  // Revoke API key
  revokeApiKey: async (id) => {
    return api.put(`/vneid-accounts/${id}/revoke-key`);
  },

  // Get assigned SDKs for an account
  getAssignedSdks: async (accountId) => {
    return api.get(`/vneid-accounts/${accountId}/sdks`);
  },

  // Assign SDK to account
  assignSdkToAccount: async (vneIdAccountId, vneIdSdkIds) => {
    return api.post('/vneid-account-sdk/assign-to-account', {
      VNeIDAccountId: vneIdAccountId,
      VNeIDSDKIds: vneIdSdkIds,
    });
  },

  // Get accounts report
  getAccountsReport: async (reportData) => {
    return api.post(config.endpoints.vneidAccounts.report, reportData);
  },

  // Export accounts report to Excel
  exportAccountsReportToExcel: async (reportData) => {
    const response = await api.post(config.endpoints.vneidAccounts.exportExcel, reportData, {
      responseType: 'blob',
    });

    const fileName = `VNeID_Accounts_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'Excel file downloaded successfully' };
  },

  // Export accounts report to PDF
  exportAccountsReportToPdf: async (reportData) => {
    const response = await api.post(config.endpoints.vneidAccounts.exportPdf, reportData, {
      responseType: 'blob',
    });

    const fileName = `VNeID_Accounts_Report_${new Date().toISOString().split('T')[0]}.pdf`;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { message: 'PDF file downloaded successfully' };
  },

  // Get VNeID authentication URL for SSO login
  getAuthUrl: async (authRequest) => {
    return api.post(config.endpoints.vneidAccounts.authUrl, authRequest);
  },

  // Get VNeID account statistics
  getStatistics: async () => {
    return api.get(config.endpoints.vneidAccounts.statistics);
  },
};

export default vneidAccountService;
